import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { IdealWeight_EndPoint } from "./ConstantsHealthCalculator";
import IdealWeightTable from "./IdealWeightTable";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Berat Badan Ideal - Menentukan Berat Badan Sehat Berdasarkan Tinggi Badan";
const DESCRIPTION =
  "Hitung berat badan ideal untuk tinggi badan Anda menggunakan kalkulator berat badan ideal - temukan berat badan yang sesuai untuk tubuh Anda dengan menggunakan kalkulator yang mudah dan terpercaya ini. Anda dapat menghitung berat badan ideal untuk wanita dan pria.";
const KEYWORDS =
  "cara menghitung berat badan ideal, menghitung indeks massa tubuh, menghitung berat badan sesuai tinggi dan usia, kalkulator berat badan ideal, menghitung BMI, menghitung berat badan ideal untuk tinggi badan, menghitung berat badan ideal berdasarkan tinggi badan, pentingnya berat badan ideal untuk kesehatan";
const OG_URL = "https://do-calculate.com/calculator/id/idealweight/";
const apiEndpoint = `${SERVER_URL}/${IdealWeight_EndPoint}`;
function IdealWeightCalculator() {
  const [height, setHeight] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const calculateIdealWeight = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ height, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Ingin tahu berat badan ideal Anda? Gunakan kalkulator berat badan ideal untuk mendapatkan berat badan yang dianggap ideal untuk kesehatan dan kebugaran fisik Anda berdasarkan tinggi badan dan jenis kelamin Anda. Kalkulator ini memberikan perhitungan akurat untuk menghitung berat badan ideal - menghitung berat badan ideal untuk tinggi badan - menghitung berat badan ideal untuk pria - menghitung berat badan ideal untuk wanita.
                <br /> Kalkulator kemudian akan menghitung berat badan ideal untuk tinggi badan dan berat badan ideal untuk setiap kasus berdasarkan jenis kelamin yang dipilih (seperti berat badan ideal untuk tinggi 160 atau 165).
                <br />
                Menghitung berat badan ideal adalah kunci penting untuk menjaga kesehatan dan kebugaran fisik. Gunakan kalkulator sekarang dan dapatkan hasil dengan cepat dan mudah. Coba hitung berat badan ideal untuk pria atau hitung berat badan ideal untuk wanita atau hitung berat badan ideal berdasarkan tinggi badan atau hitung berat badan ideal berdasarkan usia dan cek berat badan ideal Anda sekarang!
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Berat Badan Ideal
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Tinggi Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >Jenis Kelamin</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      id="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      Laki-laki
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      id="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      Perempuan
                    </label>
                  </div>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateIdealWeight}
                  disabled={isLoading}
                >
                  Hitung
                </button>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>Hasil : </h5>
                    </div>
                    <hr />
                    <IdealWeightTable result={result}></IdealWeightTable> <br />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua bidang dengan benar.{" "}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"> {TITLE}</div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Berat Badan Ideal: Semua yang Perlu Anda Ketahui tentang Berat Badan Ideal dan Cara Menghitungnya
                  </h2>{" "}
                </u>
                <p>
                  Berat badan ideal adalah istilah yang menarik perhatian banyak orang, tetapi apa sebenarnya itu? Berat badan ideal adalah berat badan yang dianggap terbaik untuk kesehatan Anda secara keseluruhan berdasarkan tinggi badan, usia, dan jenis kelamin Anda. Mengetahui berat badan ideal Anda dapat menjadi langkah penting menuju kehidupan yang sehat dan aktif. Dalam artikel ini, kita akan melihat cara menghitung berat badan ideal dan pentingnya bagi kesehatan.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Berat Badan Ideal untuk Pria dan Wanita:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Berat badan ideal berbeda antara pria dan wanita. Secara umum, berat badan ideal untuk wanita sedikit lebih rendah daripada pria karena perbedaan fisik dan komposisi biologis. Oleh karena itu, penting untuk mempertimbangkan perbedaan ini saat menentukan berat badan ideal Anda.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Berat Badan Ideal:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Kalori adalah salah satu konsep terpenting dalam dunia nutrisi dan kesehatan. Mengetahui jumlah kalori yang dibutuhkan tubuh Anda dapat menjadi kunci untuk mencapai nutrisi yang tepat dan menjaga berat badan yang sehat. Dalam artikel ini, kita akan belajar cara menghitung kalori yang dibutuhkan tubuh Anda dan pentingnya dalam menjaga kesehatan Anda.
                </p>
                Kami menggunakan 4 rumus berbeda dalam kalkulator ini untuk menghitung berat badan ideal:
                <br />
                <div>
                  <b> G. J. Hamwi Formula (1964)</b>
                  <br />
                  Rumus ini mendekati rentang yang dapat diterima. Namun, penyebarannya tidak seluas kasus Devine. Rumus ini banyak dikritik oleh kritikus yang menegaskan bahwa banyak orang yang menggunakan berat badan ideal tidak mudah menerima perubahan.<u>Dihitung sebagai berikut:</u>{" "}
                  <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        Pria : Berat badan ideal (kg) = 48 kg + 2.7 kg per cm di atas 152 cm
                      </li>
                      <li>
                        Wanita : Berat badan ideal (kg) = 45.5 kg + 2.2 kg per cm di atas 152 cm
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> B. J. Devine Formula (1974)</b>
                  <br />
                  Dalam pendekatannya, Devine menyatakan bahwa pria dengan tinggi 5 kaki (152 cm) harus memiliki berat 50 kilogram, sedangkan wanita dengan tinggi 5 kaki (152 cm) harus memiliki berat 45.5 kilogram. Untuk setiap kaki tambahan, berat badan ideal harus disesuaikan sebanyak 2.3 kilogram.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>Untuk pria: 50.0 kg + 2.3 kg per cm di atas 152 cm</li>
                      <li>Untuk wanita: 45.5 kg + 2.3 kg per cm di atas 152 cm</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <b> J. D. Robinson Formula (1983)</b>
                  <br />
                  Dalam rumusnya, Robinson mengambil rumus Devine dan menyesuaikannya dengan data empiris. Ia menemukan bahwa angka dasar untuk berat badan ideal berbeda dan juga merevisi penyesuaian untuk orang yang lebih tinggi dari 5 kaki (152 cm).
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>Untuk pria: 52 kg + 1.9 kg per cm di atas 152 cm</li>
                      <li>Untuk wanita: 49 kg + 1.7 kg per cm di atas 152 cm</li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> D. R. Miller Formula (1983)</b>
                  <br />
                  Rumus Miller digunakan untuk menghitung berat badan ideal berdasarkan tinggi badan. Sama seperti rumus lain yang disebutkan di atas, rumus Miller tidak memasukkan faktor-faktor penting yang berkontribusi pada variasi berat badan.
                  <u>Dihitung sebagai berikut:</u> <br />
                  <br />{" "}
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        Untuk pria: 56.2 kg + 1.41 kg per cm di atas 152 cm
                      </li>
                      <li>
                        Untuk wanita: 53.1 kg + 1.36 kg per cm di atas 152 cm
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
                <div>
                  <b> Rentang Sehat Indeks Massa Tubuh </b>
                  <br />
                  Organisasi Kesehatan Dunia (WHO) merekomendasikan rentang sehat Indeks Massa Tubuh (BMI) antara 18.5 dan 25 untuk pria dan wanita. Berdasarkan rentang BMI, berat badan sehat untuk setiap tinggi badan tertentu dapat diketahui.
                  <br />
                  Indeks Massa Tubuh (BMI) adalah ukuran yang banyak digunakan untuk menentukan berat badan ideal. Ini banyak digunakan di bidang medis sebagai indikator cepat potensi komplikasi kesehatan. Secara umum, semakin tinggi BMI, semakin besar kemungkinan masalah kesehatan seperti obesitas, diabetes, penyakit jantung, dan lainnya. Ini digunakan sebagai indikator oleh dokter untuk memberikan saran kesehatan kepada pasien tentang kemungkinan masalah kesehatan, terutama jika ada peningkatan BMI yang signifikan, yang merupakan ukuran resmi saat ini untuk mengklasifikasikan individu berdasarkan tingkat obesitas yang berbeda.
                </div>
                <br />
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Pentingnya Berat Badan Ideal untuk Kesehatan:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  {" "}
                  Berat badan ideal memiliki dampak signifikan pada kesehatan Anda. Jika Anda kelebihan berat badan secara tidak normal, itu dapat meningkatkan risiko berbagai penyakit seperti penyakit jantung, diabetes, dan tekanan darah tinggi. Di sisi lain, jika Anda kekurangan berat badan ideal, Anda mungkin rentan terhadap masalah kesehatan seperti osteoporosis dan kekurangan gizi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}> Kesimpulan: </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Berat badan ideal bukan sekadar angka pada timbangan. Ini tergantung pada banyak faktor pribadi termasuk tinggi badan, usia, jenis kelamin, dan tujuan kesehatan. Selalu konsultasikan dengan dokter atau profesional kesehatan sebelum mengikuti diet atau program penurunan berat badan untuk memastikan Anda mencapai tujuan Anda dengan aman dan sehat. Dengan menggunakan informasi ini dan alat sederhana seperti perhitungan BMI dan rumus lainnya, Anda dapat bekerja untuk menentukan berat badan ideal yang sesuai untuk Anda dan berkontribusi pada peningkatan kesehatan dan kualitas hidup Anda secara keseluruhan.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Berapa berat tubuh Anda?</h3>
              </div>
              <div className="info-section-body">
                Darah dalam tubuh Anda memiliki berat sekitar 7% dari total berat badan Anda.
                <br />
                Tulang Anda 15%
                <br />
                Otot Anda berkisar antara 25 hingga 50% dari berat badan Anda.
                <br />
                Persentase lemak dapat berkisar dari 6% (untuk atlet pria) hingga 31% untuk wanita (rata-rata) dan 24% untuk pria (juga rata-rata).
                <br />
                Ketika persentase lemak tubuh Anda melebihi 32% untuk wanita dan 25% untuk pria, Anda dianggap mengalami obesitas. Tetapi mengingat otot membentuk persentase besar dari potensi berat badan Anda, jelas bahwa angka yang Anda lihat pada timbangan belum tentu merupakan angka terbaik untuk diandalkan, terutama jika Anda secara teratur melakukan latihan intensif atau latihan ketahanan.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa arti berat badan sehat?</h3>
              </div>
              <div className="info-section-body">
                Berat badan sehat berarti Anda memiliki keseimbangan sehat antara lemak, otot, dan tulang, sehingga mungkin sedikit berbeda untuk setiap orang. Misalnya, berdasarkan komposisi genetik Anda, 'berat badan sehat' Anda mungkin berbeda dari pedoman kesehatan yang direkomendasikan pemerintah.
                <br />
                Jika Anda memiliki kerangka kecil dengan kelebihan berat badan yang signifikan, Anda mungkin dianggap dalam rentang berat badan sehat hanya karena kerangka kecil Anda mengimbangi angka tersebut.
                <br />
                Demikian pula, jika Anda memiliki tulang besar, itu juga dapat mempengaruhi angka yang Anda lihat pada timbangan sehingga Anda tampak memiliki kelebihan berat badan lebih dari yang sebenarnya.
                <br />
                Selain itu, tampaknya ada perbedaan dalam bagaimana komposisi genetik mempengaruhi berat badan kita. Penelitian yang diterbitkan dalam International Journal of Obesity menunjukkan bahwa hubungan antara persentase lemak tubuh dan BMI pada beberapa kelompok etnis berbeda dari yang lain, menunjukkan bahwa metode untuk memeriksa 'berat badan ideal' mungkin perlu disesuaikan tergantung pada komposisi genetik Anda.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Berapa seharusnya berat badan saya?</h3>
              </div>
              <div className="info-section-body">
                Berat badan ideal seseorang bukanlah aturan pasti. Ini sangat tergantung pada setiap individu. Sampai saat ini, tidak ada ukuran, baik IBW atau BMI atau ukuran lainnya, yang dapat secara definitif menentukan berapa berat badan seseorang untuk menjadi sehat. Itu hanya referensi, dan yang terpenting adalah tetap membuat pilihan gaya hidup sehat seperti berolahraga secara teratur, makan berbagai makanan yang tidak diproses, tidur yang cukup, dan sebagainya, daripada mengejar berat badan tertentu berdasarkan rumus umum.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana usia mempengaruhi berat badan ideal?
                </h3>
              </div>
              <div className="info-section-body">
                Secara teori, usia tidak boleh menjadi faktor besar dalam berat badan ideal setelah usia 14-15 untuk anak perempuan dan 16-17 untuk anak laki-laki, setelah itu kebanyakan orang berhenti tumbuh. Pria dan wanita diperkirakan kehilangan tinggi 1.5 dan 2 inci masing-masing pada usia 70. Penting untuk diingat bahwa seiring bertambahnya usia, otot tanpa lemak berkurang dan lebih mudah untuk mengakumulasi kelebihan lemak tubuh. Ini adalah proses alami, meskipun efek penuaan dapat dikurangi dengan mengadopsi kebiasaan yang berbeda seperti memantau pola makan, berolahraga, mengelola stres, dan memastikan tidur yang cukup.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana jenis kelamin mempengaruhi berat badan ideal?
                </h3>
              </div>
              <div className="info-section-body">
                Secara umum, wanita memiliki berat badan lebih rendah daripada pria meskipun mereka biasanya memiliki persentase lemak tubuh yang lebih tinggi secara alami. Tubuh pria umumnya memiliki massa otot yang lebih besar, dan otot lebih berat daripada lemak. Selain itu, wanita biasanya memiliki kepadatan tulang yang lebih rendah. Terakhir, pria cenderung lebih tinggi daripada wanita.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana tinggi badan mempengaruhi berat badan ideal?
                </h3>
              </div>
              <div className="info-section-body">
                Semakin tinggi seseorang, semakin besar massa otot dan lemak dalam tubuhnya, menghasilkan berat badan yang lebih besar. Pria dengan tinggi yang sama dengan wanita harus memiliki berat sekitar 10-20% lebih berat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana ukuran kerangka tubuh mempengaruhi berat badan ideal?
                </h3>
              </div>
              <div className="info-section-body">
                Ukuran kerangka tubuh adalah faktor lain yang dapat secara signifikan mempengaruhi pengukuran berat badan ideal. Ukuran kerangka tubuh biasanya diklasifikasikan sebagai kecil, sedang, atau besar. Diukur berdasarkan lingkar pergelangan tangan relatif terhadap tinggi badan. Berikut cara mengklasifikasikan ukuran kerangka tubuh: Untuk wanita: - Tinggi kurang dari 5'2": - Kecil = lingkar pergelangan tangan kurang dari 5.5 inci - Sedang = lingkar pergelangan tangan 5.5 inci hingga 5.75 inci - Besar = lingkar pergelangan tangan lebih dari 5.75 inci - Tinggi antara 5'2" dan 5'5": - Kecil = lingkar pergelangan tangan kurang dari 6 inci - Sedang = lingkar pergelangan tangan 6 inci hingga 6.25 inci - Besar = lingkar pergelangan tangan lebih dari 6.25 inci - Tinggi lebih dari 5'5": - Kecil = lingkar pergelangan tangan kurang dari 6.25 inci - Sedang = lingkar pergelangan tangan 6.25 inci hingga 6.5 inci - Besar = lingkar pergelangan tangan lebih dari 6.5 inci Untuk pria: - Tinggi lebih dari 5'5": - Kecil = lingkar pergelangan tangan 5.5 inci hingga 6.5 inci - Sedang = lingkar pergelangan tangan 6.5 inci hingga 7.5 inci - Besar = lingkar pergelangan tangan lebih dari 7.5 inci Seseorang dengan kerangka besar akan memiliki berat normal lebih berat daripada seseorang dengan kerangka kecil, bahkan pada tinggi yang sama, menjadikan ukuran kerangka tubuh sebagai faktor yang dapat mempengaruhi pengukuran seperti berat badan ideal dan BMI.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa dampak kesehatan dari berat badan tidak sehat pada wanita?
                </h3>
              </div>
              <div className="info-section-body">
                Berat badan kurang, kelebihan berat badan, dan obesitas meningkatkan risiko Anda terhadap banyak masalah kesehatan serius:
                <br />
                - Masalah siklus menstruasi. Kehilangan berat badan berlebihan dapat menyebabkan amenore atau membuatnya tidak teratur.
                <br />
                - Osteoporosis. Berat badan kurang meningkatkan risiko osteoporosis, suatu kondisi yang membuat tulang lemah dan mudah patah.
                <br />- Depresi. Penelitian menunjukkan bahwa depresi lebih umum terjadi pada wanita dengan berat badan kurang dibandingkan wanita dengan berat badan sehat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa saja tips untuk menurunkan berat badan dengan sukses?
                </h3>
              </div>
              <div className="info-section-body">
                Seberapa cepat berat badan bertambah atau berkurang dapat sangat bervariasi dari orang ke orang berdasarkan gen, metode biologis, dan masa lalu. Coba beberapa atau semua tips berikut untuk membantu Anda:
                <br />
                - Tetapkan tujuan yang realistis. Bicaralah dengan dokter atau perawat Anda tentang tujuan Anda dan cara mencapainya.
                <br />
                - Rencanakan makanan Anda sebelumnya, masak lebih banyak di rumah.
                <br />- Fokus pada makan makanan sehat. Mendapatkan kalori terutama dari protein nabati, biji-bijian utuh, buah-buahan, dan sayuran dapat membantu Anda menurunkan berat badan dengan aman.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Bagaimana berat badan mempengaruhi kesehatan?</h3>
              </div>
              <div className="info-section-body">
                Jika Anda kelebihan berat badan atau obesitas, Anda mungkin berisiko lebih tinggi terkena masalah kesehatan terkait berat badan. Kondisi ini meliputi:
                <br />
                - Penyakit jantung akibat aterosklerosis.
                <br />
                - Tekanan darah tinggi.
                <br />
                - Stroke.
                <br />
                - Diabetes tipe 2.
                <br />
                - Osteoartritis.
                <br />
                - Asam urat.
                <br />
                - Beberapa jenis kanker.
                <br />
                - Asma.
                <br />
                - Gangguan pernapasan saat tidur (sleep apnea).
                <br />
                - Masalah kesuburan pada pria dan wanita.
                <br />
                Anda mungkin juga mengalami kesulitan bernapas dan nyeri punggung bawah. Obesitas juga dapat membuat operasi dan anestesi lebih berisiko.
                <br />
                Untuk berat badan kurang, ini mungkin disebabkan oleh tidak mendapatkan cukup nutrisi yang tepat dalam pola makan. Berat badan kurang juga dapat meningkatkan risiko beberapa masalah kesehatan seperti:
                <br />
                - Kelemahan otot.
                <br />
                - Peningkatan risiko penyakit dan infeksi.
                <br />
                - Peningkatan risiko beberapa kondisi jantung.
                <br />
                - Masalah kesuburan.
                <br />
                - Penyembuhan luka lambat.
                <br />
                Mempertahankan berat badan sehat akan mengurangi kemungkinan mengembangkan masalah kesehatan ini.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default IdealWeightCalculator;